<!-- ImportHeaderRow.vue -->
<template>
    <div class="grid grid-cols-12 items-center hover:bg-gray-100 duration-300 ease-in-out">
        <div class="col-span-5">
            <div class="bg-gray-50 p-2 rounded">
                {{ left }}
            </div>
        </div>
        <div class="col-span-2">    </div>
        
        <div class="col-span-5">
            <slot name="right"></slot>
        </div>
    </div>
</template>

<script>
export default {
    props: {
        left: String,
        right: String,
    },
    computed: {
    }
}
</script>